import { IAlertSettingsRepository } from '../../domain/repositories/IAlertSettings.repository'
import { AlertSettings } from '../../domain/entities/AlertSettings'
import { HttpStatusCodeEnum } from '../../../@shared/domain/enums/HttpStatusCode.enum'
import { AlertSettingsClient } from './ports/AlertSettingsClient.port'
import { CreateAndUpdateAlertSettingsDto } from '../../domain/dtos/CreateAndUpdateAlertSettings.dto'
import { AlertSettingsSchema } from './schemas/AlertSettings.schema'

export class AlertSettingsRepositoryApiAdapter implements IAlertSettingsRepository {
	private _endpoint = '/v1/configuracao-de-alerta'

	constructor(private _httpClient: AlertSettingsClient) {}
	async delete(alertSettingsIds: string[]): Promise<void> {
		const response = await this._httpClient.delete(this._endpoint, {
			params: { id: alertSettingsIds },
			paramsSerializer: {
				indexes: null,
			},
		})

		if (response.status !== HttpStatusCodeEnum.Ok) {
			throw new Error(
				'Não foi possível excluir usuário de alerta de incêndio. Por favor, tente novamente',
			)
		}

		return
	}
	async getAll(customerId: string): Promise<AlertSettings[]> {
		const response = await this._httpClient.get(
			`${this._endpoint}/recuperar-com-usuarios-vinculados-a-id-customer/${customerId}`,
		)

		if (response.status !== HttpStatusCodeEnum.Ok) {
			return []
		}

		return response.data.map((data: any) => AlertSettingsSchema.parse(data))
	}

	async create(input: CreateAndUpdateAlertSettingsDto): Promise<void> {
		const config = {
			headers: {
				'Content-Type': 'application/json',
			},
		}

		const response = await this._httpClient.post(this._endpoint, JSON.stringify(input), config)

		if (response.status !== HttpStatusCodeEnum.Created) {
			throw new Error(
				'Não foi possível cadastrar usuário de alerta de incêndio. Por favor, tente novamente',
			)
		}

		return
	}

	async update(alertSettings: CreateAndUpdateAlertSettingsDto): Promise<void> {
		const config = {
			headers: {
				'Content-Type': 'application/json',
			},
		}
		const response = await this._httpClient.put(
			`${this._endpoint}`,
			JSON.stringify(alertSettings),
			config,
		)

		if (response.status !== HttpStatusCodeEnum.Ok) {
			throw new Error(
				'Não foi possível editar usuário de alerta de incêndio. Por favor, tente novamente',
			)
		}

		return
	}
}
